import createStore from "redux-zero";

export default createStore({
  blockUILoading: false,
  backgroundThemeColor: "gray",
});
